import Collection from './basic.js';
import _ from 'lodash';
import User from '@/models/user.js';

class Users extends Collection {
    constructor(options) {
        const opts = _.defaults({}, options, {
            baseUrl: '/mtm-gateway-api/v1/users',
            fieldName: 'users',
            idField: 'user_name',
            resource: User
        });

        super(opts);
    }

    parse(response_data) {
        const parsed_response = {
            total_count: 0,
            resources: []
        }

        if (response_data['total_count']) {
            parsed_response.total_count = response_data['total_count'];
        }

        if (response_data[this.fieldName]) {
            parsed_response.resources = response_data[this.fieldName].map((data) => {
                const r = new this.resource({
                    'baseUrl': this.baseUrl,
                    'idField': this.idField,
                    attributes: data
                });
                r._new = false;
                return r;
            });
        }

        return parsed_response;
    }
}

export default Users;
